var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackMdTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#191713"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3755_18621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5502 29.7497C24.6045 29.7497 29.5583 22.2465 29.5583 15.7416C29.5583 15.5307 29.5536 15.3151 29.5442 15.1041C30.5079 14.4072 31.3395 13.544 32 12.5551C31.1025 12.9544 30.1496 13.2151 29.1739 13.3285C30.2013 12.7127 30.9705 11.7452 31.3391 10.6055C30.3726 11.1783 29.3156 11.5824 28.2134 11.8004C27.4708 11.0113 26.489 10.4889 25.4197 10.3138C24.3504 10.1387 23.2532 10.3208 22.2977 10.8319C21.3423 11.3429 20.5818 12.1545 20.1338 13.1411C19.6859 14.1277 19.5754 15.2344 19.8195 16.2901C17.8625 16.1918 15.9479 15.6835 14.2 14.7979C12.452 13.9122 10.9097 12.6692 9.67297 11.1493C9.0444 12.233 8.85206 13.5154 9.13503 14.7358C9.418 15.9563 10.1551 17.0232 11.1964 17.7197C10.4146 17.6949 9.64998 17.4844 8.96563 17.1057V17.1666C8.96492 18.3039 9.3581 19.4063 10.0783 20.2865C10.7985 21.1667 11.8013 21.7703 12.9162 21.9947C12.1921 22.1929 11.432 22.2218 10.6948 22.0791C11.0095 23.0572 11.6216 23.9126 12.4458 24.5261C13.27 25.1395 14.2651 25.4804 15.2923 25.501C13.5484 26.8709 11.3942 27.6139 9.17656 27.6104C8.78329 27.6098 8.3904 27.5857 8 27.5382C10.2529 28.9835 12.8735 29.7511 15.5502 29.7497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3755_18621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMdTwitter);
export default __webpack_public_path__ + "static/media/black-md-twitter.7bde14ab9c4378d4ff64da761a352398.svg";
export { ForwardRef as ReactComponent };